import type { ReactNode } from 'react';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import notFound from '../../assets/not-found.png';

import {
  TXTWCL_Click_Xa_hrefXXN0XXhereX_aX_to_ELL_2,
  TXTWCL_OopsX_Page_not_found
} from './NotFound.messages.json';
import styles from './NotFound.scss';

const NotFound: React.FC = () => (
  <div className={styles.container}>
    <img className={styles.image} src={notFound} alt="" />
    <Translation {...TXTWCL_OopsX_Page_not_found}>
      {(message) => <h2 className={styles.title}>{message}</h2>}
    </Translation>
    <p className={styles.text}>
      <Translation
        {...TXTWCL_Click_Xa_hrefXXN0XXhereX_aX_to_ELL_2}
        values={{ a: (msg: ReactNode) => <a href="/">{msg}</a> }}
      />
    </p>
  </div>
);

export default NotFound;
